import React from 'react';
import FruitCrusher from "../../../assets/images/FruitCrusher.png";
import FruitDestoner from "../../../assets/images/FruitDestoner.png";
import Fruitpress from "../../../assets/images/Fruitpress.png";
import Pasteuriser from "../../../assets/images/Pasteuriser.png";
import { useTranslation } from 'react-i18next';

function FruitEquipment() {
  const { t } = useTranslation(); 

  const products = [
    {
      name: t('Fruit Crusher'),
      description: t("Robust, efficient and easy to use, our range of fruit crushers and apple mills can handle all levels of production. Designed specifically to crush your fruit to the perfect consistency for fruit pressing, they will maximize your juice yield."),
      img: FruitCrusher, 
    },
    {
      name: t('Fruit Destoner'),
      description: t("The destoning machine is used for pitting fruit (plums, cherries, sour cherries, choke-berries, apricots, peaches) for the production of quality spirits. Suitable for making jams, juices, mashing cooked fruits and vegetables, production of tomato sauce etc."),
      img: FruitDestoner, 
    },
    {
      name: t('Fruit Press'),
      description: t("The Fruit press is used for gentle processing of the fruits, which allows all the inner juices to come out without being too mashed. The extraction level can be controlled and that creates the perfect conditions for food production."),
      img: Fruitpress,
    },
    {
      name: t('Pasteuriser'),
      description: t("Juice pasteurization machine is used to sterilize the fruit juice with high heat. The sterilization process is carried out before juice filling and packing, and after juice extraction, filtration and concentrate."),
      img: Pasteuriser, 
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.img} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FruitEquipment;
